<!-- 制版设计稿查看 -->
<template>
  <!-- 新品制版设计稿明细 -->
  <h-inspection-page :title="h_i18n('af4521b8862b76095560f5d119d3c7ab')" class="Detailpicture_style" @inspection-update="inspectionUpdate">
    <!-- 新品制版设计稿明细 -->
    <form-header :title="h_i18n('af4521b8862b76095560f5d119d3c7ab')" title-height="80px" style="margin-top:8px;" v-loading="loading">
      <template #body>
        <tr>
          <!-- 供应商代码 -->
          <report-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" colspan="4:4">{{ getData.supplyCode }}</report-td>
          <!-- 供应商名称 -->
          <report-td :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" colspan="4:4">{{ getData.supplyName }}</report-td>
          <!-- 供方检验资格 -->
          <report-td :title="h_i18n('73ad4acf69901d02a25654178709e679')" colspan="4:4">{{ getData.supplyCheckLevelName }}</report-td>
        </tr>
        <tr>
          <!-- 工厂小微 -->
          <report-td :title="h_i18n('03490f3868798323211aa633194df2c1')" colspan="4:4">{{ getData.sybName }}</report-td>
          <!-- 专用号 -->
          <report-td :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" colspan="4:4">{{ getData.mtlNo }}</report-td>
          <!-- 物料名称 -->
          <report-td :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" colspan="4:4">{{ getData.mtlName }}</report-td>
        </tr>
        <tr>
          <!-- 物料大类 -->
          <report-td :title="h_i18n('33ac341a8748c430f721aa43dcf9f3b6')" colspan="4:4">{{ getData.materielCategoryName }}</report-td>
          <!-- <report-td title="提交人" colspan="4:12">{{ getData.pictureSubmitMan }}</report-td> -->
        </tr>
        <!-- 报告信息 -->
        <h-tr>{{ h_i18n('3075e304a94a1e5bf8ef4ff07fdd9fcd') }}</h-tr>
        <tr class="info_table_style">
          <!-- 序号 -->
          <td colspan="2">{{ h_i18n('faaadc447b1c2b1adc920d9c9aedcc25') }}</td>
          <!-- 报告名称 -->
          <td colspan="6">{{ h_i18n('affac2ba884d0629f91b56fd97827e8b') }}</td>
          <!-- 附件 -->
          <td colspan="12">{{ h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c') }}</td>
          <!-- 判定结论 -->
          <td colspan="4">{{ h_i18n('17b82fdb1da502972f87900f98200454') }}</td>
        </tr>
        <tr class="info_table_body_style">
          <td colspan="2">1</td>
          <!-- 制版设计稿 -->
          <td colspan="6">{{ h_i18n('2f4fd79b3f9b4a273afa62295ab7db6a') }}</td>
          <td colspan="12">
            <span style="color: #2164f5; cursor: pointer; text-overflow: ellipsis; overflow: hidden; display: block"
             @click="download(getData.pictureFileId,getData.pictureFileName)">{{ getData.pictureFileName }}</span>
          </td>
          <td colspan="4">
            <template v-if="getData.pictureCheckState == '1433'">
              <span>-</span>
            </template>
            <template v-else>
              <!-- 不合格 -->
              <span v-if="getData.pictureCheckConclusion == 'F'" class="dangerColor">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
              <!-- 合格 -->
              <span v-else-if="getData.pictureCheckConclusion == 'P'" class="successColor">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
            </template>
          </td>
        </tr>
        <!-- 审核结论 -->
        <h-tr>{{ h_i18n('8c4ab5982fcea30b260715ac494e7922') }}</h-tr>
        <tr>
          <!-- <report-td title="型号经理审核" colspan="4:4">
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="auditFlag.auditfinal"
              content="审核结果不能为空">
              <div></div>
            </el-tooltip>
            <el-radio-group v-model="auditData.auditfinal">
              <el-radio label="Y">通过</el-radio>
                <el-radio label="N">打回</el-radio>
            </el-radio-group>  
          </report-td>
          <report-td title="审核原因" colspan="4:4">
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="auditFlag.pictureCheckMark"
              content="审核原因不能为空">
              <div></div>
            </el-tooltip>
            <el-input v-model="auditData.pictureCheckMark" type="textarea" :rows="3" maxlength="200" show-word-limit
            class="input_rows_style"></el-input>
          </report-td> -->
          <!-- 审核人 -->
          <report-td :title="h_i18n('82da895cd022775edf8ccb40b8f79e8f')" colspan="4:4">
            <span>-</span>
          </report-td>
          <!-- 审核时间 -->
          <report-td :title="h_i18n('e6f0708789d7efc02f1a163224ae7fb0')" colspan="4:4">
            <span>{{ time(getData.pictureCheckTime,6) }}</span>
          </report-td>
          <!-- 作者 -->
          <report-td :title="h_i18n('62cea74981b60712a7cd869a9a021869')" colspan="4:4">
            <span>{{ getData.pictureCheckAuthor }}</span>
          </report-td>
        </tr>
        <tr>
          <!-- 审核描述 -->
          <report-td :title="h_i18n('82986e32f727e00d92e77745e709bb57')" colspan="4:20">
            <span>{{ getData.pictureCheckMark }}</span>
          </report-td>
        </tr>
      </template>
      <div style="height: 100px">
        <h-button-group align="center">
          <!-- 返回 -->
          <h-button type="default" @click="$router.back()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </div>
    </form-header>
  </h-inspection-page>
</template>



<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';


export default {
  data() {
    return{
      getData:{},

      subLoading:false
    }
  },
  methods:{
    h_i18n,
/**
 * 文件下载
 */
  download(uuid,fileName){
    this.startLoading(h_i18n('8ffe8dae6d15a5be77490834bff8d28b'))
    if(uuid && uuid.includes("http")){
      this.httpFile({
        method: "get",
        url: '/base/fileDownload/downloadFile?filePath=mkhl/bukl' + uuid.split('/mkhl/bukl')[1],
        headers: {'content-type': 'application/json'},
      }, fileName)
    }else if(uuid.includes("mkhl/bukl/")){
        this.httpFile({
          method: "get",
          url: '/base/fileDownload/downloadFile?filePath=' + uuid,
          headers: {'content-type': 'application/json'},
        }, fileName)
    }else{
      this.httpFile({
        method: "get",
        url: '/base/fileDownload/downloadFile?filePath=hmqm/reject/' + uuid,
        headers: {'content-type': 'application/json'},
      }, fileName)
    }
  },
    inspectionUpdate(){
      this.postThisPageHeight()
    },
    getDateInfo(patternPlanId){
      this.$http({
        url:'/base/newProductTemplet/searchSupplierTempletSelfCheckDetail?patternPlanId='+patternPlanId,
        method:'get',
      }).then(res=>{
        console.log(res.data.data.postDTO.documentList)
        this.getData = res.data.data.patternPlan
        this.getData.documentList = res.data.data.postDTO.documentList
        this.getData.queryFlag = res.data.data.postDTO.model.queryFlag
        this.countall = this.getData.documentList.length
        // this.auditData.auditcheck = '合格'
        // this.auditData.auditTime = this.time(new Date())
      })
    }
  },
  mounted() {
    if(this.$route.query.patternPlanId){
     this.getDateInfo(this.$route.query.patternPlanId)
    }else{
      this.info({
            // 提示
            title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
            // 暂无数据
            message: h_i18n('21efd88b67a39834582ad99aabb9dc60'),
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: () => {
              this.$router.back();
            },
          });
    }
    if (this.$route.query.name || this.$route.query.nickName) {
      window.getItemName = this.$route.query.name
      window.getItemNickName = this.$route.query.nickName

    }
    if(this.$route.query.data){
      this.getData = JSON.parse(this.$route.query.data)
    }
  }
}
</script>

<style lang="scss">
.Detailpicture_style{
  .input_rows_style {
    font-size: 16px !important;
    height: auto;

    .el-textarea__inner {
      height: auto;
    }
  }
  .info_table_style td {
      height:41px;
      font-size:14px;
      color:#666;
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
      text-align:center;
      background: #FAFAFA;
    
  }
  .info_table_body_style td {
    height:41px;
    font-size:14px;
    color:#666;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    text-align:center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &:hover {
      white-space: normal;
      word-break: break-all;
    }
  }
}
</style>